export interface SaveBarNotice {
  variant: 'success' | 'error'
  message: string
  withContactSupport?: boolean
  autoHideMs?: number
}

interface NoticeOptions {
  autoHideMs?: number
}

interface ErrorNoticeOptions extends NoticeOptions {
  withContactSupport?: boolean
}

export const successNotice = (message: string, { autoHideMs }: NoticeOptions = {}): SaveBarNotice => ({
  variant: 'success',
  message,
  ...(autoHideMs === undefined ? {} : { autoHideMs }),
})

export const withoutSuccess = (notice: SaveBarNotice | null): SaveBarNotice | null => (notice?.variant === 'success' ? null : notice)

export const errorNotice = (message: string, { withContactSupport = true, autoHideMs }: ErrorNoticeOptions = {}): SaveBarNotice => ({
  variant: 'error',
  message,
  ...(withContactSupport ? { withContactSupport } : {}),
  ...(autoHideMs === undefined ? {} : { autoHideMs }),
})
